<script lang="ts">
	import type { SbImage, SbLink } from '$lib/storyblok/types';
	import Image from '$lib/storyblok/components/image.svelte';
	import { slideIn } from '$lib/actions/slideIn';
	import { getSbUrl } from '$lib/utils/storyblok/url';
	import type { ISbStoryData } from '@storyblok/js';
	import { editable } from '$lib/storyblok/editable';

	interface Props {
		content: ISbStoryData<{
			logo: SbImage;
			label: string;
			title: string;
			link: SbLink;
		}>['content'];
		delay: number;
	}

	let { content, delay = 700 }: Props = $props();
</script>

<a
	use:editable={content}
	use:slideIn={{ delay }}
	href={getSbUrl(content.link)}
	target={content.link?.target}
	class="block opacity-[0.01]"
>
	<div
		class="flex flex-col justify-around gap-x-3 gap-y-3 rounded-xl bg-[#DA291C] px-3 py-4 text-white lg:flex-row lg:items-center lg:px-5 lg:py-6"
	>
		<Image
			src={content.logo.filename}
			alt={content.logo.alt}
			title={content.logo.title}
			height={28}
			wrapperClass="flex-shrink"
			class="max-h-4 lg:max-h-7"
		/>
		<div class="whitespace-nowrap">
			<p class="text-[12px]/[140%] font-semibold uppercase tracking-[.96px] opacity-60">
				{content.label}
			</p>
			<p class="text-[16px] tracking-[-.16px] lg:text-[20px] lg:tracking-[-.2px]">
				{content.title}
			</p>
		</div>
	</div>
</a>
